__turbopack_context__.v({
  "arrow": "NfjvmW_arrow",
  "preferenceAnchor": "NfjvmW_preferenceAnchor",
});
